import type { ComponentProps } from 'react';
import { useRef } from 'react';

import { cn, useIsClamped } from '@crm/shared/lib';

import { DealTableCell } from '../DealTableCell';

type DealNameCellProps = {
    dealName: string | null;
} & Pick<ComponentProps<typeof DealTableCell>, 'className'>;

export const DealNameCell = ({ className, dealName }: DealNameCellProps) => {
    const textRef = useRef<HTMLParagraphElement>(null);
    const isClamped = useIsClamped(textRef);
    const textContent = dealName ?? '';

    return (
        <DealTableCell
            isEmpty={!dealName}
            title={isClamped ? textContent : undefined}
            className={cn('max-w-100 py-2 pl-1', className)}
        >
            <p ref={textRef} className="min-w-0 truncate">
                {dealName}
            </p>
        </DealTableCell>
    );
};
